<template>
  <div class="flex flex-col items-start text-white m-4">
    <div class="content-start text-left text-teal-200 text-sm mt-2">Por favor ingrese la nueva contraseña</div>
    <div class="mt-2">Contraseña</div>
    <div class=""><input type="password" id="contrasena1" v-model="contrasena1" class="text-gray-800 p-1 w-full" /></div>
    <div class="mt-2">Repetir contraseña</div>
    <div><input type="password" id="contrasena2" v-model="contrasena2" class="text-gray-800 p-1 w-full" /></div>
    <div class="text-yellow-500">{{ mensajeLocal || mensaje }}</div>
    <div><button @click="cambiarContrasenaOlvidada" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Cambiar</button></div>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import { mapState } from "vuex";

export default {
  data() {
    return {
      contrasena1: "",
      contrasena2: "",
      mensajeLocal: ""
    };
  },
  methods: {
    cambiarContrasenaOlvidada() {
      if (this.contrasena1 && this.contrasena2 && this.contrasena1 === this.contrasena2) {
        this.$store.dispatch("cambiarContrasenaOlvidada", {
          hashContrasena: sha1(this.contrasena1),
          apiToken: process.env.VUE_APP_API_TOKEN
        });
      } else {
        this.mensajeLocal = "Las contraseñas son distintas";
      }
    }
  },
  computed: {
    ...mapState({
      mensaje: state => state.olvideMiContrasena.mensajeErrorCambioContrasena
    })
  }
};
</script>
